import * as yup from 'yup';
import { units } from '@/features/units/schema';

export function newProfile() {
  return {
    display_name: '',
    units: 'metric',
    nutrition_profile: null,
  };
}

export const profileSchema = yup.object({
  display_name: yup.string().required('Your name is required'),
  units: yup.string().oneOf(values(units)).required('Units are required'),
  nutrition_profile: yup.object({
    type: yup.string().oneOf(['standard', 'advanced']).required('Type is required'),

    standard: yup.object({
      birthday: yup.string().matches(/^\d{4}-\d{2}-\d{2}$/, 'Birthday must be in YYYY-MM-DD format').required('Birthday is required'),
      sex: yup.string().oneOf(['male', 'female', 'other']).required('Sex is required'),
      height: yup.number().min(0).required('Height is required'),
      weight: yup.number().min(0).required('Weight is required'),
      activity_level: yup.string().oneOf(['sedentary', 'lightly_active', 'moderately_active', 'very_active', 'extremely_active']).required('Activity level is required'),
    }).nullable(),

    advanced: yup.object({
      kcal: yup.number().min(0).required('Calories are required'),
      protein: yup.number().min(0).required('Protein is required'),
      fat: yup.number().min(0).required('Fat is required'),
      carbs: yup.number().min(0).required('Carbs are required'),
      fiber: yup.number().min(0).required('Fiber is required'),
    }).nullable(),
    
  }).test('nutrition-profile-validation', 'Standard or advanced profile must be provided', function(value) {
    if (!value) return true;
    if (value.type === 'standard' && !value.standard) return false;
    if (value.type === 'advanced' && !value.advanced) return false;
    return true;
  }).nullable(),
});

function values(options) {
  return options.map(option => option.value);
}
